import { connect } from "react-redux";
import get from "lodash/get";

import {
  getWinterGroups as onGetWinterGroups,
  selectWinterGroup as onSelectWinterGroup,
  addWinterUnitGroup as onAddWinterUnitGroup,
  deleteWinterUnitGroup as onDeleteWinterUnitGroup,
} from "../../actions/winterGroupsAction";

import {
  getWinterUnits as onGetWinterUnits,
  addWinterUnit as onAddWinterUnit,
  deleteWinterUnit as onDeleteWinterUnit,
} from "../../actions/winterUnitsAction";

const mapStateToProps = (state) => ({
  winterGroupsDataState: state.winter.winterGroupsDataState,
  winterUnitsDataState: state.winter.winterUnitsDataState,
  addWinterUnitDataState: state.winter.addWinterUnitDataState,
  deleteWinterUnitDataState: state.winter.deleteWinterUnitDataState,
  addWinterUnitGroupDataState: state.winter.addWinterUnitGroupDataState,
  deleteWinterUnitGroupDataState: state.winter.deleteWinterUnitGroupDataState,
  selectedWinterGroup: get(state, ["winter", "selectedWinterGroup"], []),
  winterGroups: get(state, ["winter", "winterGroups"], []),
  winterUnits: get(state, ["winter", "winterUnits"], []),
  errors: get(state, ["winter", "errors"], null),
});

const mapDispatchToProps = {
  onGetWinterGroups,
  onSelectWinterGroup,
  onGetWinterUnits,
  onAddWinterUnit,
  onDeleteWinterUnit,
  onAddWinterUnitGroup,
  onDeleteWinterUnitGroup,
};

const withWinter = (Component) => connect(mapStateToProps, mapDispatchToProps)(Component);

export { withWinter };
